export const MOCK_BASE_URL = 'http://localhost:8080/api';

export const LOGIN_ENDPOINT = '/auth/login';

export const OTP_ENDPOINT = '/auth/otp';

export const UPDATE_PASSWORD_ENDPOINT = 'auth/update-password';

export const excludedErrorToastEndpoints = [
  LOGIN_ENDPOINT,
  OTP_ENDPOINT,
  UPDATE_PASSWORD_ENDPOINT,
];

export const STATUS_CODES = {
  SESSION_EXPIRED: 401,
  FORBIDDEN_ACCESS: 403,
  EMPTY_TOKEN: 661,
};
